import type { ReactNode } from 'react';
import styles from './chip.module.css';
import { cx } from './cx';

/**
 * A filter chip. Renders props.
 *
 * `aria-pressed`, not `aria-current`: a chip changes *what* you are looking at rather than *where*
 * you are, and a screen reader should announce it as a toggle. `disabled` carries a `title` so that
 * §8's suppressed search filters (2c) can say *why* they are unavailable instead of just being grey.
 */
export interface ChipProps {
  readonly children: ReactNode;
  readonly selected: boolean;
  readonly onClick: () => void;
  readonly disabled?: boolean;
  readonly title?: string;
}

export function Chip({ children, selected, onClick, disabled, title }: ChipProps) {
  return (
    <button
      type="button"
      className={cx(styles.chip, selected && styles.selected)}
      aria-pressed={selected}
      disabled={disabled}
      title={title}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
